/**
 * Utility functions for storing and retrieving remembered credentials in browser localStorage.
 * Remembers both username (for password login) and email (for OTP login).
 */

const USERNAME_STORAGE_KEY = 'pg-admin:remembered-username';
const EMAIL_STORAGE_KEY = 'pg-admin:remembered-email';

/**
 * Save username to localStorage (for password sign-in)
 * @param {string} username - Username to save
 */
export const saveUsername = (username) => {
  try {
    if (username && typeof username === 'string' && username.trim()) {
      localStorage.setItem(USERNAME_STORAGE_KEY, username.trim());
    }
  } catch (error) {
    console.warn('Failed to save username to localStorage:', error);
  }
};

/**
 * Retrieve saved username from localStorage
 * @returns {string|null} Saved username or null if not found
 */
export const getSavedUsername = () => {
  try {
    const username = localStorage.getItem(USERNAME_STORAGE_KEY);
    return username ? username.trim() : null;
  } catch (error) {
    console.warn('Failed to retrieve username from localStorage:', error);
    return null;
  }
};

/**
 * Save email address to localStorage (for OTP sign-in)
 * @param {string} email - Email address to save
 */
export const saveEmail = (email) => {
  try {
    if (email && typeof email === 'string' && email.trim()) {
      localStorage.setItem(EMAIL_STORAGE_KEY, email.trim().toLowerCase());
    }
  } catch (error) {
    console.warn('Failed to save email to localStorage:', error);
  }
};

/**
 * Retrieve saved email address from localStorage
 * @returns {string|null} Saved email address or null if not found
 */
export const getSavedEmail = () => {
  try {
    const email = localStorage.getItem(EMAIL_STORAGE_KEY);
    return email ? email.trim() : null;
  } catch (error) {
    console.warn('Failed to retrieve email from localStorage:', error);
    return null;
  }
};

/**
 * Clear saved username from localStorage
 */
export const clearSavedUsername = () => {
  try {
    localStorage.removeItem(USERNAME_STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear username from localStorage:', error);
  }
};

/**
 * Clear saved email address from localStorage
 */
export const clearSavedEmail = () => {
  try {
    localStorage.removeItem(EMAIL_STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear email from localStorage:', error);
  }
};
